/* eslint-disable indent */
import { Box, Menu, MenuItem, Paper, Stack } from '@mui/material';
import styled from 'styled-components';

import { PLACEMENTS } from './constants';
import { COLORS } from '../../../theme';

export const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    color: ${COLORS.black50};
    background-color: transparent;
    box-shadow: none;
    overflow: unset;

    ${({ $arrow, theme }) =>
      $arrow &&
      `
      padding-top: 8px;

      &::before {
        position: absolute;
        top: -${theme.spacing.s2};
        right: ${theme.spacing.s4};
        z-index: 1;
        width: 0;
        height: 0;
        border: 10px solid transparent;
        border-bottom-color: ${COLORS.white};
        content: '';
      }
    `};
  }

  .MuiList-root {
    margin-bottom: ${({ $marginBottom }) => $marginBottom || '0px'};
    padding: ${({ theme }) => theme.spacing.s1};
    background-color: ${COLORS.white};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
    overflow-y: ${({ $hasSubmenu }) => ($hasSubmenu ? 'unset' : 'auto')};
    transform: translateY(
      ${({ $arrow, theme }) => ($arrow ? 0 : theme.spacing.s1)}
    );

    @supports (filter: drop-shadow(0 0 0 transparent)) {
      box-shadow: none;
      filter: drop-shadow(0 15px 20px rgba(0, 0, 0, 0.25));
      backdrop-filter: blur(0);
    }

    ${({ $fullWidthItems }) =>
      $fullWidthItems &&
      `
      padding-right: 0;
      padding-left: 0;
    `}
  }

  .MuiMenuItem-root {
    border-radius: ${({ $fullWidthItems, theme }) =>
      $fullWidthItems ? '0' : theme.borderRadius.secondary};
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  && {
    padding: ${({ theme }) => theme.spacing.s2}
      ${({ theme }) => theme.spacing.s3};
    font-size: ${({ theme }) => theme.fontSize.body2};
    line-height: ${({ theme }) => theme.lineHeight.body2};
  }

  &:hover,
  &&.Mui-selected:hover,
  &&&.MuiAutocomplete-option[aria-selected='true']:hover {
    color: ${COLORS.kinetikBlack};
    background-color: ${COLORS.black04} !important;
  }

  &&&&&.Mui-focusVisible {
    background-color: unset;
  }

  &&&.MuiAutocomplete-option[aria-selected='true'],
  &&.Mui-selected {
    position: relative;
    color: ${COLORS.kinetikBlack};
    font-weight: 500;
    background-color: transparent;

    ${({ theme, multiple }) =>
      multiple &&
      `
      &::after {
        position: absolute;
        top: 50%;
        right: ${theme.spacing.s4};
        width: 6px;
        height: 12px;
        border: 1px solid ${COLORS.kinetikBlack};
        border-width: 0 2px 2px 0;
        border-radius: 1px;
        transform: translateY(-65%) rotate(45deg);
        content: '';
      }
    `}
  }

  &.Mui-focusVisible,
  &&.Mui-selected.Mui-focusVisible {
    background-color: ${COLORS.black10};
  }

  .MuiListItemText-root .MuiTypography-root {
    font-size: ${({ theme }) => theme.fontSize.body2};
    line-height: ${({ theme }) => theme.lineHeight.body2};
  }

  && .MuiListItemIcon-root {
    color: inherit;
    min-width: auto;
    margin-right: ${({ theme }) => theme.spacing.s1};

    svg {
      font-size: ${({ theme }) => theme.fontSize.body1};

      path {
        fill: currentColor;
      }
    }
  }
`;

export const StyledMenuItemStatic = styled(Box)`
  padding: ${({ $disableGutters, theme }) =>
    $disableGutters ? 0 : `6px ${theme.spacing.s3}`};
  font-size: ${({ theme }) => theme.fontSize.body2};

  ${({ $scrollable }) =>
    $scrollable &&
    `
    max-height: 200px;
    overflow-y: auto;
  `}
`;

export const SubmenuContainer = styled(Box)`
  position: absolute;
  top: 0;
  display: ${({ open }) => (open ? 'block' : 'none')};

  ${({ placement, theme }) =>
    placement === PLACEMENTS.LEFT &&
    `
    right: 100%;
    padding-right: ${theme.spacing.s2};
  `}

  ${({ placement, theme }) =>
    placement === PLACEMENTS.RIGHT &&
    `
    left: 100%;
    padding-left: ${theme.spacing.s2};
  `}
`;

export const StyledSubmenu = styled(Paper)`
  && {
    padding: ${({ theme }) => theme.spacing.s1};
    color: ${COLORS.black50};
    background-color: ${COLORS.white};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};
    transform: translateY(-${({ theme }) => theme.spacing.s1});
    cursor: default;

    @supports not (filter: drop-shadow(0 0 0 transparent)) {
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
    }
  }
`;

export const MenuData = styled(Stack)`
  color: ${COLORS.kinetikBlack};
  min-width: 310px;
  padding: ${({ theme: { spacing } }) => `${spacing.s1} ${spacing.s3}`};
`;
